import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { _PricePropTypes } from 'src/consts'
import * as siteHelpers from '@helpers/site'
import * as Theme from '@styles/theme-const'
import Marker from '../shared/Marker/Marker'

const MarkerContainer = (props) => {
    const [markers, setMarkers] = useState([])

    useEffect(() => {
        const newMarkers = []
        if (!props.options.isBasket) {
            // Если дата поставки для доставки и самовывоза совпадает
            if (
                props.deliveryPrice?.isDemand &&
                props.stockPrice.isDemand &&
                siteHelpers.convertDate(props.deliveryPrice.aptEtaDateTime) ===
                    siteHelpers.convertDate(props.stockPrice.aptEtaDateTime)
            ) {
                newMarkers.push(
                    <Marker key="generalDemand" backgroundColor={Theme.ColorConsts.accentOrrange}>
                        Поставка {siteHelpers.convertDate(props.stockPrice.aptEtaDateTime)}
                    </Marker>
                )
            }
            // Если дата поставки для доставки и самовывоза не совпадает
            if (
                props.deliveryPrice?.isDemand &&
                props.stockPrice.isDemand &&
                siteHelpers.convertDate(props.deliveryPrice.aptEtaDateTime) !==
                    siteHelpers.convertDate(props.stockPrice.aptEtaDateTime)
            ) {
                newMarkers.push(
                    <Marker key="deliveryisDemand" backgroundColor={Theme.ColorConsts.accentOrrange}>
                        Доставка {siteHelpers.convertDate(props.deliveryPrice.aptEtaDateTime)}
                    </Marker>
                )
                newMarkers.push(
                    <Marker key="stockisDemand" backgroundColor={Theme.ColorConsts.accentOrrange}>
                        Самовывоз {siteHelpers.convertDate(props.stockPrice.aptEtaDateTime)}
                    </Marker>
                )
            }
            // если поставка только для доставки
            if (props.deliveryPrice?.isDemand && !props.stockPrice.isDemand) {
                newMarkers.push(
                    <Marker key="deliveryisDemand" backgroundColor={Theme.ColorConsts.accentOrrange}>
                        Доставка {siteHelpers.convertDate(props.deliveryPrice.aptEtaDateTime)}
                    </Marker>
                )
            }
            // если поставка только для cамовывоза
            if (!props.deliveryPrice?.isDemand && props.stockPrice?.isDemand) {
                newMarkers.push(
                    <Marker key="stockisDemand" backgroundColor={Theme.ColorConsts.accentOrrange}>
                        Самовывоз {siteHelpers.convertDate(props.stockPrice.aptEtaDateTime)}
                    </Marker>
                )
            }
        } else {
            if (props.options.isDelivery && props.deliveryPrice.isDemand) {
                newMarkers.push(
                    <Marker key="isDemand" backgroundColor={Theme.ColorConsts.accentOrrange}>
                        Доставка {siteHelpers.convertDate(props.deliveryPrice.aptEtaDateTime)}
                    </Marker>
                )
            } else if (!props.options.isDelivery && props.stockPrice.isDemand) {
                newMarkers.push(
                    <Marker key="isDemand" backgroundColor={Theme.ColorConsts.accentOrrange}>
                        Самовывоз {siteHelpers.convertDate(props.stockPrice.aptEtaDateTime)}
                    </Marker>
                )
            }
        }
        if (props.isOriginalGood) {
            newMarkers.push(
                <Marker key="isOriginalGood" backgroundColor={Theme.ColorConsts.greenYellowLight}>
                    Оригинальный препарат
                </Marker>
            )
        }
        if (props.isCold) {
            newMarkers.push(
                <Marker key="isCold" backgroundColor={Theme.ColorConsts.blueLight}>
                    Хранение в холоде
                </Marker>
            )
        }
        if (props.isAvailableDeliveryByErecipe) {
            newMarkers.push(
                <Marker key="isAvailableDeliveryByErecipe" backgroundColor={Theme.ColorConsts.blueLight}>
                    Доставка по рецепту
                </Marker>
            )
        }
        if (props.isStrictlyByPrescription) {
            newMarkers.push(
                <Marker key="isStrictlyByPrescription" backgroundColor={Theme.ColorConsts.redLight}>
                    Строго по рецепту
                </Marker>
            )
        }
        /*   if(props.deliveryStatus?.isAvailableForDelivery || good.isAvailableDeliveryByErecipe)*/
        setMarkers(newMarkers)
    }, [props])

    return <React.Fragment>{markers.map((x) => x)}</React.Fragment>
}

MarkerContainer.propTypes = {
    options: PropTypes.shape({
        isBasket: PropTypes.bool,
        isDelivery: PropTypes.bool
    }),
    isStrictlyByPrescription: PropTypes.bool,
    isAvailableDeliveryByErecipe: PropTypes.bool,
    isOriginalGood: PropTypes.bool,
    isCold: PropTypes.bool,
    stockPrice: _PricePropTypes,
    deliveryPrice: _PricePropTypes
}

MarkerContainer.defaultProps = {
    options: {
        isBasket: false,
        isDelivery: false
    }
}

export default MarkerContainer
